import { lazier } from '@shared/components';

export const ApproveAdvancementsModal = lazier(
  () => import('./ApproveAdvancementsModal'),
  false,
);
export { default as ApproveAdvancementsAction } from './ApproveAdvancementsAction';
export { default as ApproveAdvancementsButton } from './ApproveAdvancementsButton';

export { default as DeclineAdvancementsButton } from './DeclineAdvancementsButton';

export const DeclineMultipleAdvancementModal = lazier(
  () => import('./DeclineMultipleAdvancementModal'),
  false,
);
